const prefix = "account";

export const AUTOPAY = `${prefix}/AUTOPAY`;
export const AUTOPAY_CHANGE = `${prefix}/AUTOPAY_CHANGE`;
export const AUTOPAY_CHANGE_FAILED = `${prefix}/AUTOPAY_CHANGE_FAILED`;

export const SUB_NOTIFICATION = `${prefix}/SUB_NOTIFICATION`;
export const SUB_NOTIFICATION_CHANGE = `${prefix}/SUB_NOTIFICATION_CHANGE`;
export const SUB_NOTIFICATION_CHANGE_FAILED = `${prefix}/SUB_NOTIFICATION_CHANGE_FAILED`;
